import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PSIcon from './PSIcon';
import PSLoading from "./PSLoading";
import ReactTooltip from 'react-tooltip';

const StyledPSDynamicTable = styled.div`
  background: #fff;
  width: 100%;
  .container-table {
    border-spacing: 0px 10px;
    width: 100%;
    text-align:left;
    .table-header {
      color: #002655;
      font-size: 12px;
      padding-left:10px;
      .table-header-field {
        padding: 0.5rem 10px;
      }
      .header-info-basic{
        padding-left:10px;
      }
      .th-check {
        width: 15px;
      }
    }
    .tr-body{
      cursor:pointer;
      &:hover{
        background: #f5f5f5;
      }
      
    }
    .table-item {
      font-family: 'Gotham-Book', sans-serif;
      color: #002655;
      padding: 0.7rem 10px;
      .item-actions {
        filter: opacity(0.6);
        display: flex;
        justify-content: space-around;
      }
      .item-info-basic{
          font-family: 'Gotham-Medium', sans-serif;
          display:flex;
          .info-photo{
            width: 32px;
            height: 32px;
            border-radius:50px;
            background:red;
            margin-right:10px;
            svg{
            border-radius: 15px;
          }
          }
         .info-name{
          font-size: 12px;
          text-transform: capitalize;
        }
         .info-mail{
          font-size: 10px;
          opacity: 0.5;
        }
      }
    }
    // .table-item-first {
    //   border-left: 1px solid #e9ecef;
    // }a
    // .table-item-last {
    //   border-right: 1px solid #e9ecef;
    // }
  }
`;

export const  PSDynamicTable = React.forwardRef(({headers, items, onSelect, withCheck, selectUser, loading}, ref) => {
  const userBackground = '';
  const [listSelect, setListSelect] = useState([]);

  const onCheck = (id, value) => {
    if (value) {
      listSelect.push(id);
      setListSelect([...listSelect]);
    } else {
      const listSelectFiler = listSelect.filter((item) => {
        return item !== id;
      });
      setListSelect([...listSelectFiler]);
    }
  };


  return (
    <StyledPSDynamicTable ref={ref} userBackground={userBackground}  className={`${loading? "align-all-center":" "}`}>
      {loading ?
        <PSLoading color='orange'/>
        :
        <table className="container-table">
          <thead>
          <tr className="table-header">
            {withCheck && <th className="th-check"/>}
            <th className="table-header-field header-info-basic">INFORMACIÓN BÁSICA</th>

            {headers.map((header) => (
              <th key={header.elementProp} className="table-header-field">
                {header.headerColumn}
              </th>
            ))}
            <th className="table-header-field">ACCIONES</th>
            <th className="table-header-field">CREADO</th>
            <th className="table-header-field">ACTUALIZADO</th>
          </tr>
          </thead>
          <tbody>
          {items.map((item, index) => {
            return (
              <tr key={`user-${index}`} onClick={ () => selectUser(item)} className="tr-body">
                {withCheck && (
                  <td className="table-item">
                    <input
                      type="checkbox"
                      onChange={(event) => onCheck(item.id, event.target.checked)}
                    />
                  </td>
                )}
                <td className="table-item">
                  <div className="item-info-basic">
                    <div className="info-photo">
                      <PSIcon type="profile"/>
                    </div>
                    <div>
                      <div className="info-name">{item.name}</div>
                      <div className="info-mail">{item.mail}</div>
                    </div>
                  </div>
                </td>
                {headers.map((header, i) => (
                  <td
                    className={`table-item${i === 0 && !withCheck ? ' table-item-first' : ' '}`}
                    key={item.id + header.elementProp}
                  >
                    {item[header.elementProp]}
                  </td>
                ))}
                <td className="table-item">
                  <div className="item-actions">
                    <PSIcon data-tip="Bloquear usuario"  type="block"/>
                    <PSIcon data-tip="Desbloquear usuario" type="unlock"/>
                    <PSIcon data-tip="Eliminar usuario" type="delete"/>
                  </div>
                </td>
                <td className="table-item">{item.createDate}</td>
                <td className="table-item table-item-last">{item.updateDate}</td>
              </tr>
            );
          })}
          </tbody>
          <ReactTooltip place="top" type="dark"/>
        </table>
      }
    </StyledPSDynamicTable>
  );
});

PSDynamicTable.displayName = 'PSDynamicTable';

PSDynamicTable.defaultProps = {
  showCheck: false,
  headers: [],
  items: [],
  withCheck: false,
  loading: false,
  onSelect: () => {},
  selectUser: () => {},
};

PSDynamicTable.propTypes = {
  showCheck: PropTypes.bool,
  headers: PropTypes.array,
  onSelect: PropTypes.func,
  withCheck: PropTypes.bool,
  loading: PropTypes.bool,
  selectUser: PropTypes.func,
};

export default PSDynamicTable;
